/* v2-cart-drawer.js - moved out of the page into a cached asset (was inline).
   Runs once per page; in the theme editor it re-runs when a section reloads,
   exactly as the inline version did. */
(function () {
if (window.__v2Asset_v2_cart_drawer_js) return;
window.__v2Asset_v2_cart_drawer_js = 1;
function v2run() {
(function () {
window.__v2CartBuild = 'v2-drawer 2026-09-08b cart-errors';
var drawer = document.querySelector('cart-drawer.v2-cart');
if (!drawer) return;
if (window.__v2CartDrawer === drawer) return;
if (typeof window.__v2CartDrawerStop === 'function') {
try { window.__v2CartDrawerStop(); } catch (e) { /* a stale run is not fatal */ }
}
window.__v2CartDrawer = drawer;
var teardown = [];
function own(o) {
teardown.push(function () { try { o.disconnect(); } catch (e) {} });
return o;
}
window.__v2CartDrawerStop = function () {
for (var i = 0; i < teardown.length; i++) {
try { teardown[i](); } catch (e) { /* keep going: a half-stopped run is worse */ }
}
teardown.length = 0;
window.__v2AddedWatch = null;
window.__v2CartDrawer = null;
};
var SPECS_VIEW = '?view=v2-specs';
try {
window.sessionStorage.setItem('v2:bagReturn', location.pathname + location.search);
} catch (e) {}
(function () {
var want = false;
try {
var stamp = parseInt(window.sessionStorage.getItem('v2:openBag'), 10);
if (stamp) window.sessionStorage.removeItem('v2:openBag');
want = !!stamp && Date.now() - stamp < 30000;
} catch (e) {}
if (!want) return;
drawer.classList.add('animate', 'active');
if (document.body) document.body.classList.add('overflow-hidden');
window.__v2BagReturned = true;
var tries = 0;
(function tryOpen() {
if (typeof drawer.open === 'function') {
drawer.open();
try {
var tab = window.sessionStorage.getItem('v2:openTab');
if (tab) window.sessionStorage.removeItem('v2:openTab');
if (tab === 'wish') setTimeout(function () { if (typeof show === 'function') show('wish'); }, 450);
} catch (e) {}
return;
}
if (++tries < 60) setTimeout(tryOpen, 50);
})();
})();
var justAdded = false;
var justShown = false;
function shipBy(lead) {
var d = new Date();
d.setDate(d.getDate() + (isNaN(lead) ? 14 : lead));
if (d.getDay() === 6) d.setDate(d.getDate() + 2);
if (d.getDay() === 0) d.setDate(d.getDate() + 1);
try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
}
function wishShipLine(mode) {
var tpl = bagCfg(mode === 'fitted' ? 'fit' : mode === 'gift' ? 'gift' : 'len') || '';
if (!tpl) return '';
var d = document.createElement('div');
d.innerHTML = tpl.replace(/\{date\}/g, shipBy(14)).replace(/\{days\}/g, 14);
return (d.textContent || '').replace(/\s+/g, ' ').trim();
}
function paintMade(scope) {
(scope || drawer).querySelectorAll('[data-v2c-made]').forEach(function (el) {
var mode = el.getAttribute('data-v2c-made') || 'length';
var lead = parseInt(el.getAttribute('data-lead'), 10);
var key = mode === 'fitted' ? 'fitted' : mode === 'gift' ? 'gift' : 'length';
var tpl = el.getAttribute('data-' + key) || '';
if (!tpl.replace(/&nbsp;|\s/g, '')) {
tpl = bagCfg(key === 'length' ? 'len' : key === 'fitted' ? 'fit' : 'gift') || '';
}
var out = tpl.replace(/\{date\}/g, shipBy(lead)).replace(/\{days\}/g, isNaN(lead) ? 14 : lead);
if (el.getAttribute('data-v2c-madeout') === out) return;
el.setAttribute('data-v2c-madeout', out);
el.innerHTML = out;
});
}
var current = 'bag';
function bagPanel() {
var live = document.getElementById('CartDrawer-CartItems');
if (!live) return null;
var host = live.closest('[data-v2c-panel="bag"]')
|| live.closest('cart-drawer-items')
|| live.closest('.v2c-panel');
if (host && host.getAttribute('data-v2c-panel') !== 'bag') {
host.setAttribute('data-v2c-panel', 'bag');
if (!host.classList.contains('v2c-panel')) host.classList.add('v2c-panel');
}
return host;
}
function applyPanels() {
bagPanel();
document.querySelectorAll('[data-v2c-panel]').forEach(function (p) {
var want = p.getAttribute('data-v2c-panel') !== current;
if (p.hidden !== want) p.hidden = want;
var inline = p.style.getPropertyValue('display') === 'none';
if (inline !== want) {
if (want) p.style.setProperty('display', 'none', 'important');
else p.style.removeProperty('display');
}
});
document.querySelectorAll('[data-v2c-tab]').forEach(function (t) {
var on = t.getAttribute('data-v2c-tab') === (current === 'just' ? 'bag' : current);
var was = t.getAttribute('aria-selected');
if (was !== (on ? 'true' : 'false')) t.setAttribute('aria-selected', on ? 'true' : 'false');
});
markView();
sweepStrays();
watchPanels();
}
function sweepStrays() {
var panel = drawer.querySelector('[data-v2c-panel="' + current + '"]');
drawer.querySelectorAll('.v2c-item, .cart-item, tr.cart-item').forEach(function (row) {
var mine = panel && panel.contains(row);
var swept = row.getAttribute('data-v2c-swept') === '1';
if (!mine && !swept) {
row.setAttribute('data-v2c-swept', '1');
row.style.setProperty('display', 'none', 'important');
} else if (mine && swept) {
row.removeAttribute('data-v2c-swept');
row.style.removeProperty('display');
}
});
}
var panelWatch = null;
function watchPanels() {
if (!panelWatch) panelWatch = own(new MutationObserver(function () { applyPanels(); }));
panelWatch.disconnect();
document.querySelectorAll('[data-v2c-panel]').forEach(function (p) {
panelWatch.observe(p, { attributes: true,
attributeFilter: ['hidden', 'class', 'style'] });
});
}
function show(which) {
current = which;
applyPanels();
if (which === 'wish') { paintWishlist(); addedShow(false); }
}
function markView() {
var want = current === 'just' ? 'bag' : current;
if (drawer.getAttribute('data-v2c-view') !== want) {
drawer.setAttribute('data-v2c-view', want);
}
}
var WISH_SEL = drawer.getAttribute('data-v2c-wish-sel') || '';
var WISH_ON  = drawer.getAttribute('data-v2c-wish-open') === 'true';
var WISH_OPENED = /\b(active|animate|is-open|open)\b/;
function theirWishDrawer() { return document.querySelector('wishlist-drawer'); }
function wrapWishOpen() {
try {
if (!window.customElements || !customElements.whenDefined) return false;
} catch (err) { return false; }
customElements.whenDefined('wishlist-drawer').then(function () {
/* Only this page's wishlist drawer is redirected, on the element itself -
   the wishlist-drawer class is left exactly as the theme defines it. */
var wd = theirWishDrawer();
if (!wd || wd.__v2WishWrapped) return;
wd.__v2WishWrapped = true;
wd.open = function () { takeOverWishDrawer(this); };
window.__v2WishHook = { hooked: true, by: 'open()', watching: true };
})['catch'](function () { /* the class watcher below still covers it */ });
return true;
}
function takeOverWishDrawer(wd) {
try { if (typeof wd.close === 'function') wd.close(); } catch (err) { /* not fatal */ }
wd.classList.remove('active', 'animate', 'is-open', 'open');
window.__v2WishHook = { hooked: true, by: 'wishlist-drawer' };
openWishlist();
}
var wishArmed = false;
function watchTheirWishDrawer() {
if (wishArmed) return true;
var wd = theirWishDrawer();
if (!wd || !WISH_ON) return false;
wishArmed = true;
wrapWishOpen();
if (window.MutationObserver) {
own(new MutationObserver(function (recs) {
for (var i = 0; i < recs.length; i++) {
var t = recs[i].target;
if (!t || !t.tagName || t.tagName.toLowerCase() !== 'wishlist-drawer') continue;
if (WISH_OPENED.test(t.className || '')) { takeOverWishDrawer(t); return; }
}
})).observe(document.body, { attributes: true, subtree: true,
attributeFilter: ['class'] });
if (WISH_OPENED.test(wd.className || '')) takeOverWishDrawer(wd);
}
window.__v2WishHook = { hooked: true, by: 'class watch', watching: true };
return true;
}
var WISH_YES = /wish\s*-?\s*list|favou?rite/i;
var WISH_NO  = /cart|bag|checkout|account|log\s*in|sign\s*in|search|menu|order|home/i;
function headerish(el) {
return !!el.closest('header, .header, .site-header, .header-wrapper, ' +
'[id*="header" i], [class*="header" i]');
}
function saysWhat(el) {
return [el.getAttribute('aria-label'), el.getAttribute('title'),
el.getAttribute('href'), el.className && el.className.baseVal !== undefined
? el.className.baseVal : el.className,
el.id, el.getAttribute('data-testid'), el.textContent]
.join(' ');
}
function wishTrigger(target) {
if (!WISH_ON || !target || !target.closest) return null;
if (WISH_SEL) {
var picked = target.closest(WISH_SEL);
return picked || null;
}
var el = target.closest('a, button, [role="button"]');
if (!el) return null;
if (drawer.contains(el)) return null;
if (el.closest('[data-v2-groups], [data-v2-sticky]')) return null;
if (!headerish(el)) return null;
var says = saysWhat(el);
if (!WISH_YES.test(says)) return null;
if (WISH_NO.test(says)) return null;
return el;
}
var wishOpening = false;
var wishOpenAt = 0;
function openWishlist() {
wishOpening = true;
wishOpenAt = Date.now();
show('wish');
try {
if (typeof drawer.open === 'function') { drawer.open(); return; }
} catch (err) { /* fall through to the class fallback */ }
drawer.classList.add('animate', 'active');
}
function wrapCartOpen() {
try {
if (!window.customElements || !customElements.whenDefined) return;
} catch (err) { return; }
customElements.whenDefined('cart-drawer').then(function () {
/* Wrap open() on this drawer element only, so a normal "open cart" lands
   on the Bag tab. The cart-drawer class itself is not touched. */
if (!drawer || drawer.__v2OpenWrapped) return;
var theirs = drawer.open;
if (typeof theirs !== 'function') return;
drawer.__v2OpenWrapped = true;
drawer.open = function () {
if (!wishOpening && current === 'wish') show('bag');
wishOpening = false;
return theirs.apply(this, arguments);
};
})['catch'](function () { /* nothing to put back */ });
}
wrapCartOpen();
if (!watchTheirWishDrawer()) {
window.__v2WishHook = { hooked: false, by: 'looking for wishlist-drawer' };
var wishTries = 0;
var wishIv = setInterval(function () {
if (watchTheirWishDrawer() || ++wishTries > 40) clearInterval(wishIv);
}, 100);
teardown.push(function () { clearInterval(wishIv); });
document.addEventListener('DOMContentLoaded', watchTheirWishDrawer);
window.addEventListener('load', function () {
if (!watchTheirWishDrawer() && !wishArmed) {
window.__v2WishHook = { hooked: false, by: 'no wishlist-drawer on the page' };
}
});
}
function pkgHost() { return document.querySelector('[data-v2c-pkg]'); }
function pkgPaint(value) {
var host = pkgHost(); if (!host) return;
var v = value == null ? '' : String(value);
if (host.getAttribute('data-current') !== v) host.setAttribute('data-current', v);
Array.prototype.forEach.call(host.querySelectorAll('[data-v2c-pkg-opt]'), function (b) {
var on = b.getAttribute('data-v2c-pkg-opt') === v;
if (b.getAttribute('aria-checked') !== String(on)) b.setAttribute('aria-checked', String(on));
});
}
function pkgWrite(value) {
var host = pkgHost(); if (!host) return Promise.resolve();
var attrs = {}; attrs[host.getAttribute('data-key') || 'Packaging'] = value;
return fetch('/cart/update.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ attributes: attrs })
}).then(function (r) { return r.ok ? r.json() : null; })
.then(function (cart) { return cart ? pkgApplyLines(cart, value) : cart; })
.catch(function () { return null; });
}
function pkgKeyName() { var h = pkgHost(); return (h && h.getAttribute('data-key')) || 'Packaging'; }
/* Checkout cannot show cart attributes, but it does list line-item properties (any key that does not
   start with "_") under each item. So the packaging choice is mirrored onto every cart line as a
   property, keeping the cart attribute as well for the order record. Existing properties (bundle
   markers, fitting details, "_v2") are copied across untouched, because /cart/change.js replaces the
   whole property set of a line. Lines are updated one at a time from the cart the server returns,
   since a change can merge or re-key lines. */
var pkgLinesBusy = false;
function pkgApplyLines(cart, value) {
if (!cart || !cart.items || !value || pkgLinesBusy) return Promise.resolve(cart);
var key = pkgKeyName(), changed = false, guard = 0;
function needs(c) {
for (var i = 0; i < c.items.length; i++) {
var pr = c.items[i].properties || {};
if (String(pr[key] == null ? '' : pr[key]) !== String(value)) return i;
}
return -1;
}
function done(c) {
pkgLinesBusy = false;
if (changed) { try { paintBagSoon(); } catch (e) {} }
return c;
}
function next(c) {
var i = needs(c);
if (i < 0 || guard++ > 25) return done(c);
var it = c.items[i], props = {};
Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
props[key] = String(value);
return fetch('/cart/change.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ line: i + 1, quantity: it.quantity, properties: props })
}).then(function (r) { return r.ok ? r.json() : null; })
.then(function (c2) { if (!c2 || !c2.items) return done(c); changed = true; return next(c2); })
.catch(function () { return done(c); });
}
pkgLinesBusy = true;
return next(cart);
}
var pkgCart = null;
function pkgOpened() { return window.__v2PkgOpened === true; }
function pkgSeed() {
window.__v2PkgOpened = true;
if (window.__v2PkgSeeded) return;
var host = pkgHost(); if (!host) return;
if (!pkgCart || !(pkgCart.item_count > 0)) return;
var key = host.getAttribute('data-key') || 'Packaging';
if (pkgCart.attributes && pkgCart.attributes[key]) return;   /* the cart has said */
window.__v2PkgSeeded = true;
var def = host.getAttribute('data-default') || '';
pkgPaint(def);
pkgWrite(def);
}
function pkgSync(cart) {
var host = pkgHost(); if (!host || !cart) return;
pkgCart = cart;
var key = host.getAttribute('data-key') || 'Packaging';
var have = cart.attributes && cart.attributes[key] ? String(cart.attributes[key]) : '';
if (have) {
var old = host.querySelector('[data-v2c-pkg-was="' + have.replace(/"/g, '\\"') + '"]');
if (old && !window.__v2PkgRenamed) {
window.__v2PkgRenamed = true;
var now = old.getAttribute('data-v2c-pkg-opt') || '';
pkgPaint(now); pkgWrite(now); return;
}
pkgPaint(have); pkgApplyLines(cart, have); return;
}
pkgPaint(host.getAttribute('data-default') || '');
if (pkgOpened()) pkgSeed();
}
function v2cClick(e) {
var pk = e.target && e.target.closest ? e.target.closest('[data-v2c-pkg-opt]') : null;
if (pk) {
var val = pk.getAttribute('data-v2c-pkg-opt') || '';
pkgPaint(val);
window.__v2PkgSeeded = true;
pkgWrite(val);
return;
}
var el = wishTrigger(e.target);
if (!el) return;
e.preventDefault();
e.stopPropagation();
window.__v2WishHook = { hooked: true, by: WISH_SEL ? 'selector' : 'header guess',
says: (el.getAttribute('aria-label') || el.getAttribute('href') ||
(el.textContent || '').trim()).slice(0, 60) };
openWishlist();
}
document.addEventListener('click', v2cClick, true);
teardown.push(function () { document.removeEventListener('click', v2cClick, true); });
function lsGet(k) {
try { return window.localStorage.getItem(k); } catch (e) { return null; }
}
function lsSet(k, v) {
try { window.localStorage.setItem(k, v); } catch (e) { /* nothing to do */ }
}
function saved(key) {
var raw = lsGet(key);
if (!raw) return [];
return raw.split(',').filter(function (x) { return x !== '' && x !== 'null'; });
}
function handleOf(url) {
var m = String(url).split('?')[0].split('/products/')[1];
return m ? m.split('/')[0] : null;
}
var SPEC_RETRY_AFTER = 10000;
var specCache = {};
var specFailed = {};
function specsFor(handle) {
if (specCache[handle]) return specCache[handle];
var failedAt = specFailed[handle];
if (failedAt && Date.now() - failedAt < SPEC_RETRY_AFTER) return Promise.resolve(null);
var asking = fetch('/products/' + handle + SPECS_VIEW, { credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.text() : null; })
.then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
.catch(function () { return null; })
.then(function (data) {
if (data) { specCache[handle] = Promise.resolve(data); delete specFailed[handle]; }
else { specFailed[handle] = Date.now(); if (specCache[handle] === asking) delete specCache[handle]; }
return data;
});
specCache[handle] = asking;
return asking;
}
function updateWishCount() {
var n = saved('wishlist-ids').length;
var el = drawer.querySelector('[data-v2c-wishcount]');
var want = '(' + n + ')';
if (el && el.textContent !== want) el.textContent = want;
return n;
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
var wishSpecs = {};
function wishExtras() {
try { return JSON.parse(lsGet('v2-wish-extras') || '{}') || {}; } catch (e) { return {}; }
}
/* The line properties a wishlist piece gets when it moves to the bag. Shared with "Share Wishlist" (via
   window.__v2WishLineProps), so a shared wishlist adds to the recipient's bag exactly as the heart list does. */
function wishLineProps(vid, noShips) {
var props = {};
(wishSpecs[String(vid)] || []).forEach(function (pair) {
var k = String(pair[2] || pair[0]), v = specVal(pair[0], pair[1]);
if (/^fitting$/i.test(k)) v = /gift/i.test(v) ? 'Gift Package' : 'Piercing Concierge\u00AE';
if (k === 'Bar Length' || k === 'Fitting') k = '_' + k;
props[k] = v;
});
props._v2 = '1';
if (!noShips) {
var ship = wishShipFor(props);
if (ship) props.Ships = ship;
}
return props;
}
function wishShipFor(props) {
try {
var fitVal = props.Fitting || props['_Fitting'] || '';
var shipMode = /gift/i.test(fitVal) ? 'gift' : /concierge/i.test(fitVal) ? 'fitted' : 'length';
return wishShipLine(shipMode) || '';
} catch (err) { return ''; }   /* no line is better than a wrong one */
}
window.__v2WishLineProps = function (vid, opts) {
return wishSpecs[String(vid)] ? wishLineProps(vid, !!(opts && opts.noShips)) : null;
};
window.__v2WishShipFor = wishShipFor;
function wishRow(id, url, data) {
var v = data && data.variants ? data.variants[id] : null;
var specs = v && v.specs ? v.specs : [];
/* Choices that aren't variants (e.g. the birthstone month) were saved when
   the heart was pressed; add them, then label and order rows as the bag does. */
var extras = wishExtras()[String(id)] || [];
var merged = specs.slice();
extras.forEach(function (x) {
if (!x || !x[0] || !x[1]) return;
var k = specMap(String(x[0]));
for (var m = 0; m < merged.length; m++) {
if (specLow(merged[m][0]) === specLow(k)) return;
}
merged.push([k, String(x[1]), String(x[0])]);
});
wishSpecs[String(id)] = merged;
var order = specCfg('specorder').split(',').map(specLow).filter(function (x) { return !!x; });
var rows = merged.map(function (s, at) {
var r = order.indexOf(specLow(s[0]));
return { s: s, at: at, rank: r < 0 ? order.length : r };
}).sort(function (a, b) { return a.rank - b.rank || a.at - b.at; })
.map(function (x) {
return '<dt>' + esc(x.s[0]) + '</dt><dd>' + esc(specVal(x.s[0], x.s[1])) + '</dd>';
}).join('');
var img = data && data.image
? '<img src="' + esc(data.image) + '" alt="" loading="lazy" width="200">' : '';
return '<div class="v2c-item" data-wish-id="' + esc(id) + '">' +
'<a href="' + esc(url) + '" class="v2c-shot" tabindex="-1" aria-hidden="true">' + img + '</a>' +
'<div class="v2c-txt">' +
'<a href="' + esc(url) + '" class="v2c-title">' + esc(data ? data.title : '') + '</a>' +
'<p class="v2c-price">' + esc(v ? v.price : '') + '</p>' +
(rows ? '<dl class="v2c-spec">' + rows + '</dl>' : '') +
'<div class="v2c-acts">' +
'<button type="button" data-v2c-wishadd data-id="' + esc(id) + '"' +
(v && v.available ? '' : ' disabled') + '>Add to bag</button>' +
'<button type="button" data-v2c-wishremove data-id="' + esc(id) + '">Remove</button>' +
'</div>' +
'</div></div>';
}
function paintEmpty() {
var wish = drawer.querySelector('[data-v2c-ewish]');
var sign = drawer.querySelector('[data-v2c-esign]');
if (!wish && !sign) return;
var n = saved('wishlist-ids').length;
if (wish) {
var go = wish.querySelector('[data-v2c-ewishgo]');
if (go && n) {
var tpl = n === 1 ? (go.getAttribute('data-v2c-one') || '')
: (go.getAttribute('data-v2c-many') || '');
var words = tpl.replace('{n}', n);
if (go.textContent !== words) go.textContent = words;
}
if (wish.hidden === (n > 0)) wish.hidden = !(n > 0);
}
if (sign && sign.hidden !== (n > 0)) sign.hidden = n > 0;
}
/* Layout-shift fix (saving a cart item to the wishlist): the bag empties and Dawn re-renders the empty state with both
   "saved" / "sign in" spans still hidden, so the lede is ONE line. paintEmpty() only ran from repaint()'s 40ms timer, so
   one or two frames painted that one-line version before the span appeared and the lede wrapped to TWO lines, pushing
   everything below it down 24px (CLS ~0.06). A MutationObserver callback runs before the next paint, so the right span
   is revealed in the same frame the empty state is inserted. paintEmpty() is idempotent, so this cannot loop. */
if (window.MutationObserver) {
/* Same idea for the mobile add-to-cart shifts (~0.08-0.19): every re-render swaps in the server's markup, which has the
   "Made for you" line EMPTY and the "Added to your bag" banner HIDDEN. They were only restored from repaint()'s timer, so a
   frame or two painted without them and the content below jumped (banner -40px, then the made-line +27px).
   Restoring them in this callback (it runs before the next paint) removes the gap. Both calls are idempotent. */
own(new MutationObserver(function () {
paintEmpty();
paintMade();
if (addedOn) addedShow(true);
})).observe(drawer, { childList: true, subtree: true });
}
function showSignin(on) {
var el = drawer.querySelector('[data-v2c-signin]');
if (el && el.hidden === on) el.hidden = !on;
}
function paintWishlist() {
var host = drawer.querySelector('[data-v2c-wishrows]');
var empty = drawer.querySelector('[data-v2c-wishempty]');
if (!host) return;
var ids = saved('wishlist-ids'), urls = saved('wishlist-urls');
updateWishCount();
paintEmpty();
if (!ids.length) {
host.innerHTML = '';
if (empty) empty.hidden = false;
showSignin(false);
return;
}
if (empty) empty.hidden = true;
showSignin(true);
var jobs = ids.map(function (id, i) {
var url = urls[i] || '';
var h = handleOf(url);
return (h ? specsFor(h) : Promise.resolve(null)).then(function (data) {
return wishRow(id, url, data);
});
});
Promise.all(jobs).then(function (html) {
var next = html.join('');
if (host.innerHTML !== next) host.innerHTML = next;
});
}
function dropWish(id) {
try { var ex = wishExtras(); if (ex[String(id)]) { delete ex[String(id)]; lsSet('v2-wish-extras', JSON.stringify(ex)); } } catch (e) {}
var ids = saved('wishlist-ids');
var at = ids.indexOf(String(id));
if (at < 0) return false;
['wishlist-ids', 'wishlist-titles', 'wishlist-urls',
'wishlist-materials', 'wishlist-prices', 'wishlist-images'].forEach(function (k) {
var list = saved(k);
list.splice(at, 1);
lsSet(k, list.length ? list.join(',') + ',' : '');
});
return true;
}
function pushWish(d) {
var pairs = [['wishlist-ids', d.id], ['wishlist-titles', d.title], ['wishlist-urls', d.url],
['wishlist-materials', d.material || ''], ['wishlist-prices', d.price],
['wishlist-images', d.image]];
if (saved('wishlist-ids').indexOf(String(d.id)) > -1) return;
pairs.forEach(function (p) {
var cur = lsGet(p[0]) || '';
lsSet(p[0], cur + p[1] + ',');
});
}
/* Removing (or saving to the wishlist) the LAST line empties the bag, which narrows the drawer 900px -> 564px.
   That used to happen only after /cart/change AND a second /cart.js round trip (~0.8s after the click): a visible
   jump, and outside the browser's 500ms "recent input" window, so it also counted as layout shift. Narrow it at the
   click instead, then confirm with the real cart and put the wide layout back if the removal did not go through. */
var optimisticEmpty = false;
var pendingAdds = 0;   /* wishlist adds still in flight: the rows on screen are then not the whole cart */
function bagRowCount() {
return drawer.querySelectorAll('#CartDrawer-CartItems .v2c-item').length;
}
drawer.addEventListener('click', function (e) {
var rmBtn = e.target.closest && e.target.closest('cart-remove-button');
if (!rmBtn || optimisticEmpty || pendingAdds > 0 || bagRowCount() !== 1 || drawer.getAttribute('data-v2c-bag') !== 'full') return;
optimisticEmpty = true;
drawer.setAttribute('data-v2c-bag', 'empty');
setTimeout(function () {
fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
.then(function (r) { return r.json(); })
.then(function (c) {
optimisticEmpty = false;
var want = c && c.item_count === 0 ? 'empty' : 'full';
if (drawer.getAttribute('data-v2c-bag') !== want) drawer.setAttribute('data-v2c-bag', want);
}).catch(function () { optimisticEmpty = false; });
}, 2500);
}, true);
drawer.addEventListener('click', function (e) {
var el;
if ((el = e.target.closest('[data-v2c-tab]'))) { show(el.getAttribute('data-v2c-tab')); return; }
if ((el = e.target.closest('[data-v2c-viewall]'))) { show('bag'); return; }
if ((el = e.target.closest('[data-v2c-keep]'))) {
addedShow(false);
if (typeof drawer.close === 'function') drawer.close();
return;
}
if ((el = e.target.closest('[data-v2c-ewishgo]'))) {
e.preventDefault(); show('wish'); return;
}
if ((el = e.target.closest('[data-v2c-klaviyo]'))) {
var formId = el.getAttribute('data-v2c-klaviyo');
var kl = window._klOnsite;
if (formId && kl && typeof kl.push === 'function'
&& !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {
e.preventDefault();
/* Close the drawer first: it keeps keyboard focus inside itself, which
   would stop anyone typing into the Klaviyo form. */
try { if (typeof drawer.close === 'function') drawer.close(); } catch (err) {}
setTimeout(function () {
try { kl.push(['openForm', formId]); } catch (err) {
window.location.href = el.getAttribute('href');
}
}, 350);
}
return;
}
if ((el = e.target.closest('[data-v2c-step]'))) {
var input = el.parentNode.querySelector('input[name="updates[]"]');
if (!input) return;
var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(el.getAttribute('data-v2c-step'), 10));
input.value = String(next);
input.dispatchEvent(new Event('change', { bubbles: true }));
return;
}
if ((el = e.target.closest('[data-v2c-tobag-wish]'))) {
pushWish({ id: el.dataset.id, title: el.dataset.title, url: el.dataset.url,
material: el.dataset.material, price: el.dataset.price,
image: el.dataset.image });
try {
var lineProps = JSON.parse(el.getAttribute('data-props') || '{}') || {};
var keepX = [];
Object.keys(lineProps).forEach(function (k) {
if (!k || k.charAt(0) === '_' || k === 'Delivery' || k === 'Ships' || k === pkgKeyName()) return;
if (lineProps[k] == null || String(lineProps[k]).trim() === '') return;
keepX.push([k, String(lineProps[k])]);
});
var exAll = wishExtras();
if (keepX.length) exAll[String(el.dataset.id)] = keepX; else delete exAll[String(el.dataset.id)];
lsSet('v2-wish-extras', JSON.stringify(exAll));
} catch (err) { /* the variant still moves; only the extra choices are skipped */ }
updateWishCount();
var row = el.closest('.cart-item');
var rm = row && row.querySelector('cart-remove-button');
if (rm) rm.click();
return;
}
if ((el = e.target.closest('[data-v2c-wishremove]'))) {
dropWish(el.getAttribute('data-id'));
paintWishlist();
return;
}
if ((el = e.target.closest('[data-v2c-wishadd]'))) {
var vid = el.getAttribute('data-id');
el.disabled = true;
var wideNow = false;
optimisticEmpty = false;
if (drawer.getAttribute('data-v2c-bag') === 'empty') { drawer.setAttribute('data-v2c-bag', 'full'); wideNow = true; }
var props = wishLineProps(vid);
pendingAdds++;
fetch('/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: props }],
sections: 'cart-icon-bubble' })
}).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
.then(function (res) {
try {
var bub = document.getElementById('cart-icon-bubble');
var html = res && res.sections && res.sections['cart-icon-bubble'];
if (bub && html) {
var tmp = document.createElement('div'); tmp.innerHTML = html;
var fresh = tmp.querySelector('#cart-icon-bubble');
if (fresh) bub.innerHTML = fresh.innerHTML;
}
} catch (err) { /* the count is decoration; the add is done */ }
dropWish(vid);
updateWishCount();
paintWishlist();
drawer.classList.remove('is-empty');
show('bag');
repaint();
setTimeout(function () { pendingAdds = Math.max(0, pendingAdds - 1); }, 1500);   /* rows need a moment to paint */
})
.catch(function () {
pendingAdds = Math.max(0, pendingAdds - 1);
el.disabled = false;
if (wideNow && bagRowCount() === 0 && drawer.getAttribute('data-v2c-bag') !== 'empty') drawer.setAttribute('data-v2c-bag', 'empty');
});
return;
}
});
function v2cSubmit(ev) {
var f = ev.target;
if (!f || !f.getAttribute) return;
if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
justAdded = true;
justShown = false;
/* Layout-shift fix: the drawer opens ~0.9s after the click in its narrow "empty" layout and only widens to the full
   layout (order-summary column, 564px -> 900px) when repaint() flips data-v2c-bag about 150ms later - a jump of
   ~0.17 CLS. The bag is about to have items, so switch to the final layout now, before the drawer opens. If the add
   fails and the cart is still empty, repaint() below puts the empty layout back. */
var optimisticBag = false;
if (drawer.getAttribute('data-v2c-bag') === 'empty') {
drawer.setAttribute('data-v2c-bag', 'full');
optimisticBag = true;
}
/* Phones: the "Added to your bag" banner used to appear only at the first repaint, ~1s after the drawer opened, pushing the
   item down 54px. It is in the markup already (hidden), so show it now, before the drawer opens. Hidden again below if the
   add fails. */
if (phone()) addedShow(true);
setTimeout(function () {
justAdded = false;
if (!drawer.classList.contains('active')) addedShow(false);   /* closed during the window: don't leave a stale banner */
if (optimisticBag) {
optimisticBag = false;
/* reconcile with the real cart. repaint() alone is not enough: it returns early when the cart is unchanged
   (still empty after a rejected add) and never resets the layout flag. */
fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
.then(function (r) { return r.json(); })
.then(function (c) {
var want = c && c.item_count === 0 ? 'empty' : 'full';
if (drawer.getAttribute('data-v2c-bag') !== want) drawer.setAttribute('data-v2c-bag', want);
if (want === 'empty') addedShow(false);   /* nothing was added, so there is nothing to announce */
})
.catch(function () { /* leave it; the next repaint() corrects it */ });
}
}, 4000);
}
document.addEventListener('submit', v2cSubmit, true);
teardown.push(function () { document.removeEventListener('submit', v2cSubmit, true); });
function paintJust() {
var host = drawer.querySelector('[data-v2c-just-row]');
var id = drawer.productId;
if (!host || !id) return false;
var input = drawer.querySelector('input[data-quantity-variant-id="' + id + '"]');
var row = input && input.closest('.cart-item');
if (!row) return false;
var clone = row.cloneNode(true);
clone.querySelectorAll('.v2c-qty, .v2c-acts, .v2c-err').forEach(function (n) { n.remove(); });
clone.removeAttribute('id');
var pr = clone.querySelector('.v2c-price');
var unit = pr && pr.getAttribute('data-v2c-unit');
if (pr && unit) {
pr.innerHTML = unit;
pr.removeAttribute('data-v2c-unit');
}
/* Loop fix: sweepStrays() marks the bag's real row data-v2c-swept + display:none while the "just added" view shows, so
   this clone inherits that, and the same sweep then strips it again once the clone sits in the visible panel. The markup
   in the host therefore never matched `next`, so every repaint rewrote it, which fired the observers, which repainted
   again: ~30 rewrites a second for the whole 4s "just added" window. Compare (and write) a canonical form that has the
   sweep's bookkeeping removed, so identical content is never rewritten. */
function justClean(root) {
root.querySelectorAll('[data-v2c-swept]').forEach(function (n) { n.removeAttribute('data-v2c-swept'); });
root.querySelectorAll('[style]').forEach(function (n) {
n.style.removeProperty('display');
if (!n.getAttribute('style')) n.removeAttribute('style');
});
return root;
}
var wrap = document.createElement('div');
wrap.appendChild(clone);
var next = justClean(wrap).innerHTML;
var have = justClean(host.cloneNode(true)).innerHTML;
if (have !== next) host.innerHTML = next;
return true;
}
var bagBusy = false;
var bagAgain = false;
var bagCfgCache = {};
function bagCfg(name) {
if (Object.prototype.hasOwnProperty.call(bagCfgCache, name)) return bagCfgCache[name];
var el = drawer.querySelector('[data-v2c-panel="bag"]') || bagPanel();
var v = el ? (el.getAttribute('data-v2c-' + name) || '') : '';
if (v) bagCfgCache[name] = v;
return v;
}
function bagText(v) {
return String(v == null ? '' : v)
.replace(/<[^>]*>/g, '')
.replace(/&nbsp;?/gi, ' ')
.replace(/[\s\u00a0\u200b\u200c\u200d\ufeff]+/g, ' ')
.trim();
}
function stateSync(cart) {
var empty = cart.item_count === 0;
if (drawer.classList.contains('is-empty') !== empty) drawer.classList.toggle('is-empty', empty);
var ck = document.getElementById('CartDrawer-Checkout');
if (ck && ck.disabled !== empty) ck.disabled = empty;
var total = bagMoney(cart.total_price);
[drawer.querySelector('[data-v2c-subtotal]'), drawer.querySelector('.v2c-stot dd')]
.forEach(function (el) { if (el && bagText(el.textContent) !== bagText(total)) el.textContent = total; });
var pay = drawer.querySelector('.v2c-pay');
var marks = drawer.querySelector('.v2c-marks');
var n = pay ? (parseInt(pay.getAttribute('data-v2c-payn'), 10) || 4) : 4;
var each = bagMoney(Math.round((cart.total_price || 0) / n));
payFig(each);
var hide = !(cart.total_price > 0);
var row = drawer.querySelector('[data-v2c-payrow]');
[row, pay, marks].forEach(function (el) { if (el && el.hidden !== hide) el.hidden = hide; });
payPair();
}
var bagCurrency = '';
function bagMoney(cents) {
var n = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
var amt = n.join('.');
var fmt = bagText(bagCfg('money'));
var open = '{' + '{', close = '}' + '}';
var i = fmt.indexOf(open), j = fmt.indexOf(close);
if (i < 0 || j <= i) return '$' + amt + (bagCurrency ? ' ' + bagCurrency : '');
return fmt.slice(0, i) + amt + fmt.slice(j + close.length);
}
var SPEC_FALLBACK = {
relabel: 'Pick Your Charm Connector=Connector,Charm Connector=Connector,'
+ 'Connector Type=Connector,Material Option=Metal,Material=Metal,'
+ 'Metal Option=Metal,Birthstone=Birthstone,Stone Option=Stone,Pick Your Stone=Stone,Gauge Option=Gauge',
relabellike: 'connector=Connector,material=Metal,metal=Metal,stone=Stone,'
+ 'gauge=Gauge,bar length=Bar Length,fitting=Fitting',
drop: 'eligible for bundle discount,bundle discount,eligible for a bundle',
specorder: 'Stone,Birthstone,Metal,Gauge,Connector,Bar Length,Fitting',
fill: 'Stone,Metal,Gauge,Bar Length'
};
function specCfg(name) {
var v = bagCfg(name);
return v || SPEC_FALLBACK[name] || '';
}
function specLow(name) {
return String(name || '').replace(/[\s\u00a0]+/g, ' ').replace(/[:：]\s*$/, '')
.trim().toLowerCase();
}
function specMap(name) {
var low = specLow(name);
var pairs = specCfg('relabel').split(',');
for (var i = 0; i < pairs.length; i++) {
var bits = pairs[i].split('=');
if (bits.length === 2 && specLow(bits[0]) === low) return bits[1].trim();
}
var order = specCfg('specorder').split(',');
for (var o = 0; o < order.length; o++) {
if (specLow(order[o]) && specLow(order[o]) === low) return String(name).trim();
}
var rules = specCfg('relabellike').split(',');
for (var r = 0; r < rules.length; r++) {
var rb = rules[r].split('=');
if (rb.length !== 2) continue;
var needle = specLow(rb[0]);
if (needle && low.indexOf(needle) > -1) return rb[1].trim();
}
return name;
}
/* "16g (thinner)" / "14g (standard navel)" -> "16g" / "14g": the variant names
   carry a helper note the bag and wishlist don't need. */
function specVal(key, val) {
var v = String(val == null ? '' : val);
if (specLow(key) === 'gauge') v = v.replace(/\s*\(.*\)\s*$/, '').trim();
return v;
}
function specDropped(name) {
var gone = specCfg('drop').split(',');
var low = specLow(name);
for (var i = 0; i < gone.length; i++) {
var g = specLow(gone[i]);
if (g && low.indexOf(g) > -1) return true;
}
return false;
}
function specLines(props, options) {
var out = [];
var have = {};
Object.keys(props).forEach(function (k) {
var shownKey = (k === '_Bar Length' || k === '_Fitting') ? k.slice(1) : k;
if (shownKey === k && k.charAt(0) === '_') return;
if (k === 'Delivery' || k === 'Ships' || k === pkgKeyName()) return;
var v = bagText(props[k]);
if (!v) return;
var posted = bagText(shownKey);
if (specDropped(posted)) return;
shownKey = specMap(posted);
if (specDropped(shownKey)) return;
have[specLow(shownKey)] = true;
out.push([shownKey, v]);
});
if (options && options.forEach) {
options.forEach(function (o) {
if (!o || !o.value || o.value === 'Default Title') return;
var ov = bagText(o.value);
if (!ov) return;
var posted = bagText(o.name);
if (specDropped(posted)) return;
var key = specMap(posted);
if (specDropped(key) || have[specLow(key)]) return;
have[specLow(key)] = true;
out.push([key, ov]);
});
}
var order = specCfg('specorder').split(',').map(function (x) { return x.trim().toLowerCase(); })
.filter(function (x) { return !!x; });
var rank = function (key) {
var i = order.indexOf(String(key).trim().toLowerCase());
return i < 0 ? order.length : i;
};
out = out.map(function (row, i) { return { row: row, at: i, rank: rank(row[0]) }; })
.sort(function (a, b) { return a.rank - b.rank || a.at - b.at; })
.map(function (x) { return x.row; });
var html = '';
for (var i = 0; i < out.length; i++) {
html += '<dt>' + esc(out[i][0]) + '</dt><dd>' + esc(specVal(out[i][0], out[i][1])) + '</dd>';
}
return html;
}
function fillSpecs(cart) {
if (!cart || !cart.items || !cart.items.length) return;
var want = specCfg('fill').split(',').map(specLow).filter(function (x) { return !!x; });
if (!want.length) return;
var rows = drawer.querySelectorAll('#CartDrawer-CartItems .v2c-item');
var n = Math.min(rows.length, cart.items.length);
for (var i = 0; i < n; i++) fillOne(cart.items[i], rows[i], want);
}
function fillOne(it, row, want) {
var dl = row.querySelector('.v2c-spec');
var pairs = [];
var have = {};
if (dl) {
var kids = dl.children;
for (var k = 0; k + 1 < kids.length; k += 2) {
if (kids[k].tagName !== 'DT' || kids[k + 1].tagName !== 'DD') continue;
var key = kids[k].textContent.trim();
pairs.push([key, kids[k + 1].textContent.trim()]);
have[specLow(key)] = true;
}
}
var short = false;
for (var w = 0; w < want.length; w++) if (!have[want[w]]) short = true;
if (!short) return;
var handle = handleOf(it.url);
if (!handle) return;
specsFor(handle).then(function (data) {
var v = data && data.variants
? (data.variants[String(it.variant_id)] || data.variants[String(it.id)]) : null;
var specs = (v && v.specs) || [];
if (!specs.length) return;
var added = false;
for (var s = 0; s < specs.length; s++) {
var key = String(specs[s][0] || '');
var val = String(specs[s][1] || '');
var low = specLow(key);
if (!val || have[low]) continue;
if (want.indexOf(low) < 0) continue;   /* only the labels she listed */
have[low] = true;
pairs.push([key, val]);
added = true;
}
if (!added) return;
var order = specCfg('specorder').split(',').map(specLow)
.filter(function (x) { return !!x; });
pairs = pairs.map(function (row2, at) {
var r = order.indexOf(specLow(row2[0]));
return { row: row2, at: at, rank: r < 0 ? order.length : r };
}).sort(function (a, b) { return a.rank - b.rank || a.at - b.at; })
.map(function (x) { return x.row; });
var html = '';
for (var q = 0; q < pairs.length; q++) {
html += '<dt>' + esc(pairs[q][0]) + '</dt><dd>' + esc(specVal(pairs[q][0], pairs[q][1])) + '</dd>';
}
var target = row.querySelector('.v2c-spec');
if (!target) {
target = document.createElement('dl');
target.className = 'v2c-spec';
var made = row.querySelector('.v2c-made');
if (made && made.parentNode) made.parentNode.insertBefore(target, made);
else return;
}
if (target.innerHTML !== html) target.innerHTML = html;
});
}
function bagRow(it, n) {
var props = it.properties || {};
var isV2 = Object.prototype.hasOwnProperty.call(props, '_v2');
var spec = specLines(props, it.options_with_values || null);
var fit = String(props.Fitting || props['_Fitting'] || '');
var mode = fit.indexOf('Gift') > -1 ? 'gift'
: fit.indexOf('Concierge') > -1 ? 'fitted' : 'length';
var img = it.image || (it.featured_image && it.featured_image.url) || '';
var price = it.original_line_price !== it.final_line_price
? '<s>' + esc(bagMoney(it.original_line_price)) + '</s>' + esc(bagMoney(it.final_line_price))
: esc(bagMoney(it.original_line_price));
var qn = parseInt(it.quantity, 10) || 1;
var unitAttr = '';
if (qn > 1) {
var uOrig = Math.round(Number(it.original_line_price) / qn);
var uFinal = Math.round(Number(it.final_line_price) / qn);
var unit = uOrig !== uFinal
? '<s>' + esc(bagMoney(uOrig)) + '</s>' + esc(bagMoney(uFinal))
: esc(bagMoney(uOrig));
unitAttr = ' data-v2c-unit="' + esc(unit) + '"';
}
var discs = [];
(function(){
var raw = it.line_level_discount_allocations || it.discounts || [];
if (!raw || !raw.length) return;
for (var d = 0; d < raw.length; d++) {
var one = raw[d] || {};
var app = one.discount_application || one;
var t = bagText(app.title);
if (t) discs.push(t);
}
})();
var discHtml = '';
if (discs.length) {
discHtml = '<ul class="v2c-disc" aria-label="Discount">';
for (var q = 0; q < discs.length; q++) discHtml += '<li>' + esc(discs[q]) + '</li>';
discHtml += '</ul>';
}
var metal = bagText(props.Metal);
if (!metal && it.options_with_values) {
it.options_with_values.forEach(function (o) {
if (o && /material|metal/i.test(o.name || '')) metal = o.value;
});
}
var url = String(it.url || '').split('?')[0];
return '' +
'<div id="CartDrawer-Item-' + n + '" class="cart-item v2c-item">' +
'<a href="' + esc(it.url) + '" class="v2c-shot" tabindex="-1" aria-hidden="true">' +
(img ? '<img class="cart-item__image" src="' + esc(img) + '" alt="" loading="lazy" width="200">' : '') +
'</a>' +
'<div class="v2c-txt">' +
'<a href="' + esc(it.url) + '" class="v2c-title cart-item__name">' +
esc(bagText(it.product_title || it.title)) + '</a>' +
'<p class="v2c-price"' + unitAttr + '>' + price + '</p>' +
discHtml +
(spec ? '<dl class="v2c-spec">' + spec + '</dl>' : '') +
'<p class="v2c-made" data-v2c-made="' + mode + '"' +
' data-lead="14"' +
' data-length="' + esc(bagCfg('len')) + '"' +
' data-fitted="' + esc(bagCfg('fit')) + '"' +
' data-gift="' + esc(bagCfg('gift')) + '"></p>' +
'<div class="v2c-qty">' +
'<button type="button" data-v2c-step="-1" aria-label="Decrease quantity">&minus;</button>' +
'<input type="number" name="updates[]" value="' + (it.quantity || 1) + '" min="0"' +
' id="Drawer-quantity-' + n + '" data-index="' + n + '"' +
' data-quantity-variant-id="' + esc(it.variant_id || it.id) + '"' +
' aria-label="Quantity">' +
'<button type="button" data-v2c-step="1" aria-label="Increase quantity">+</button>' +
'</div>' +
'<div class="v2c-acts">' +
'<button type="button" data-v2c-tobag-wish' +
' data-material="' + esc(metal) + '"' +
' data-id="' + esc(it.variant_id || it.id) + '"' +
' data-title="' + esc(it.product_title || it.title) + '"' +
' data-url="' + esc(url) + '"' +
' data-price="' + esc(bagMoney(it.original_line_price)) + '"' +
' data-image="' + esc(img) + '"' +
' data-props="' + esc(JSON.stringify(props || {})) + '"' +
' data-index="' + n + '">' + esc(bagCfg('wishword') || 'Wishlist') + '</button>' +
'<cart-remove-button id="Remove-' + n + '" data-index="' + n + '">' +
'<a href="/cart/change?line=' + n + '&quantity=0" aria-label="Remove">' +
esc(bagCfg('removeword') || 'Remove') + '</a>' +
'</cart-remove-button>' +
'</div>' +
'<p class="v2c-err" id="CartDrawer-LineItemError-' + n + '" role="alert">' +
'<span class="cart-item__error-text"></span></p>' +
'</div>' +
'</div>';
}
function why(w) { window.__v2BagWhy = w; return undefined; }
var ERR = window.__v2CartErr = window.__v2CartErr || {
total: 0,
by: {
ok:      { n: 0, url: '', at: 0 },
r429:    { n: 0, url: '', at: 0 },
r430:    { n: 0, url: '', at: 0 },
other4xx:{ n: 0, url: '', at: 0 },
r5xx:    { n: 0, url: '', at: 0 },
network: { n: 0, url: '', at: 0 }
},
events: [],
retries: 0,   /* times our own read was asked a second time */
told: 0,      /* times the shopper was actually shown the line */
busy: false   /* is the line up right now */
};
var ERR_KEEP = 20;
var CART_READ  = /(^|\/)cart\.js$/;
var CART_WRITE = /(^|\/)cart\/(add|change|update|clear)(\.js)?$/;
function errPath(u) {
var s = String(u || '');
var q = s.indexOf('?'); if (q > -1) s = s.slice(0, q);
var h = s.indexOf('#'); if (h > -1) s = s.slice(0, h);
return s;
}
function errNow() { return Date.now(); }
function errBucket(status) {
if (!status) return 'network';
if (status < 400) return 'ok';
if (status === 429) return 'r429';
if (status === 430) return 'r430';
if (status >= 500) return 'r5xx';
return 'other4xx';
}
function errRecord(meta, status, ms) {
var kind = errBucket(status);
var at = errNow();
ERR.total++;
var slot = ERR.by[kind];
if (slot) { slot.n++; slot.url = meta.path; slot.at = at; }
ERR.events.push({ url: meta.path, status: status || 0, at: at, ms: Math.round(ms) });
if (ERR.events.length > ERR_KEEP) ERR.events.splice(0, ERR.events.length - ERR_KEEP);
if ((kind === 'r429' || kind === 'r430') && meta.write) busyNote(true);
else if (kind === 'ok') busyNote(false);
}
ERR.summary = function () {
var b = ERR.by;
var blocked = b.r429.n + b.r430.n;
var out = 'Cart: ' + ERR.total + ' request' + (ERR.total === 1 ? '' : 's')
+ ' on this page, ' + b.ok.n + ' fine';
if (blocked) {
var last = b.r429.at > b.r430.at ? b.r429 : b.r430;
out += ', ' + blocked + ' turned away by Shopify (429/430) - last was '
+ last.url + ' at ' + new Date(last.at).toLocaleTimeString();
}
if (b.other4xx.n) out += ', ' + b.other4xx.n + ' refused for another reason';
if (b.r5xx.n) out += ', ' + b.r5xx.n + ' Shopify errors';
if (b.network.n) out += ', ' + b.network.n + ' never got through at all';
out += '. Shopper asked to try again: ' + ERR.told
+ '. Quiet retries: ' + ERR.retries + '.';
if (!blocked && !b.network.n && !b.r5xx.n) out += ' Nothing wrong here.';
return out;
};
function busyNote(on) {
ERR.busy = !!on;
busySync();
}
function busySync() {
var el = document.querySelector('cart-drawer.v2-cart [data-v2c-busy]');
if (!el) return;
var want = !ERR.busy;
if (el.hidden === want) return;
el.hidden = want;
if (!want) ERR.told++;
}
/* Cart health: counts cart calls and shows the "try again" line when
   Shopify turns a cart write away (429/430). Nothing global is overridden:
   the drawer's own reads go through cartFetch(); everything else is seen
   passively through Dawn's cart events and the browser's resource timing. */
function cartFetch(url, init) {
/* The drawer's own cart reads. If Shopify says "too many requests" (429),
   ask once more after the wait it names (capped). Counting is left to the
   passive observer below so nothing is counted twice. */
return fetch(url, init).then(function (r) {
if (r && r.status === 429) return cartRetry(url, init, r);
return r;
});
}
function cartRetry(url, init, r) {
var RETRY_CAP = 5000;      /* Retry-After is honoured, but never past this */
var wait = 1500;           /* what we wait when Shopify did not say */
try {
var ra = r.headers && r.headers.get('Retry-After');
if (ra) {
var secs = parseFloat(ra);
if (isFinite(secs) && secs >= 0) wait = Math.min(secs * 1000, RETRY_CAP);
}
} catch (e) {}
ERR.retries++;
return new Promise(function (settle) {
setTimeout(function () {
fetch(url, init).then(settle, function () { settle(r); });
}, wait);
});
}
if (!window.__v2CartWatch) {
window.__v2CartWatch = 1;
/* Dawn's own cart events: a successful update clears the line; an error
   that reads as "too many requests" raises it. Dawn's pubsub.js loads with
   defer, after this script, so the hookup waits for it. */
var subscribed = false;
function hookCartEvents() {
if (subscribed) return;
try {
if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') return;
subscribed = true;
subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
try { busyNote(false); } catch (e) {}
});
subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
try {
var said = [ev && ev.message, ev && ev.errors].join(' ');
if (/too many|throttl|429|430|try again/i.test(said)) busyNote(true);
} catch (e) {}
});
} catch (e) { /* the events are a bonus; the drawer works without them */ }
}
hookCartEvents();
if (!subscribed) {
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', hookCartEvents);
} else {
setTimeout(hookCartEvents, 0);
}
}
/* Passive network view: the browser reports every finished cart request,
   including other apps' XHR calls, without anything being wrapped. Status
   codes are available in Chrome/Edge; elsewhere this simply counts. */
try {
if (window.PerformanceObserver) {
new PerformanceObserver(function (list) {
list.getEntries().forEach(function (en) {
var path = '';
try { path = errPath(new URL(en.name, location.href).pathname); } catch (e) { return; }
var read = CART_READ.test(path), write = CART_WRITE.test(path);
if (!read && !write) return;
if (en.initiatorType !== 'fetch' && en.initiatorType !== 'xmlhttprequest') return;
/* No status (Safari/Firefox): count it, but let Dawn's events alone decide
   whether the "try again" line shows. */
if (typeof en.responseStatus !== 'number' || !en.responseStatus) { ERR.total++; return; }
try { errRecord({ path: path, read: read, write: write }, en.responseStatus, en.duration); } catch (e) {}
});
}).observe({ type: 'resource', buffered: false });
}
} catch (e) { /* older browsers: nothing is counted, nothing breaks */ }
}
var BAG_MIN_GAP = 800;
var bagLast = 0;
var bagTrail = 0;
function paintBagSoon() {
if (bagTrail) return;                 /* one trailing call, never a queue */
var wait = BAG_MIN_GAP - (Date.now() - bagLast);
if (wait <= 0) { paintBag(); return; }
bagTrail = setTimeout(function () { bagTrail = 0; paintBag(); }, wait);
}
function bagFailOpen() {
var ck = document.getElementById('CartDrawer-Checkout');
if (!ck || !ck.disabled) return;
if (!drawer.querySelector('.cart-item')) return;
ck.disabled = false;
if (window.__v2CartTrace && window.__v2CartTrace.length < 30) {
window.__v2CartTrace.push('checkout re-enabled: rows on screen, cart call failed');
}
}
function paintBag() {
if (bagBusy) { bagAgain = true; return why('busy - queued'); }
var host = drawer.querySelector('#CartDrawer-CartItems');
if (!host) return why('no list element');
bagBusy = true;
bagLast = Date.now();
cartFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store',
headers: { 'X-Requested-With': 'XMLHttpRequest' } })
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (cart) {
if (!cart || !cart.items || typeof cart.items.length !== 'number') {
bagFailOpen();
return why('cart.js gave no items');
}
bagCurrency = cart.currency || '';
pkgSync(cart);
stateSync(cart);
var sig = cart.items.map(function (i) {
return (i.key || i.id) + ':' + i.quantity +
':' + i.original_line_price + ':' + i.final_line_price;
}).join('|') + '#' + cart.item_count + '#' + (cart.total_price || 0);
var live = drawer.querySelector('#CartDrawer-CartItems');
if (!live) return why('list element went away');
if (live.getAttribute('data-v2c-sig') === sig &&
(cart.items.length === 0 || live.querySelector('.v2c-item'))) {
fillSpecs(cart);
return why('unchanged');
}
var rows = '';
for (var i = 0; i < cart.items.length; i++) rows += bagRow(cart.items[i], i + 1);
if (cart.items.length > 0 && !rows) return why('built no rows');
var free = bagCfg('free');
var head = (cart.items.length && free)
? '<p class="v2c-free">' + esc(free) + '</p>' : '';
var region = document.getElementById('CartDrawer-LiveRegionText');
var status = document.getElementById('CartDrawer-LineItemStatus');
live.innerHTML = head + rows;
if (region) live.appendChild(region);
if (status) live.appendChild(status);
live.setAttribute('data-v2c-sig', sig);
window.__v2BagPaints = (window.__v2BagPaints || 0) + 1;
why('painted');
var bagN = drawer.querySelector('#v2cTabBag .n');
if (bagN) bagN.textContent = '(' + cart.item_count + ')';
Array.prototype.forEach.call(drawer.querySelectorAll('[data-v2c-count]'),
function (n) { n.textContent = cart.item_count; });
var panel = drawer.querySelector('[data-v2c-panel="bag"]');
if (panel) panel.classList.toggle('is-empty', cart.item_count === 0);
var wantBag = cart.item_count === 0 ? 'empty' : 'full';
/* a repaint that read the cart before the removal finished must not undo the click-time narrowing */
if (drawer.getAttribute('data-v2c-bag') !== wantBag && !(optimisticEmpty && wantBag === 'full') && !(pendingAdds > 0 && wantBag === 'empty')) {
drawer.setAttribute('data-v2c-bag', wantBag);
}
paintEmpty();
paintMade(live);
fillSpecs(cart);
applyPanels();
})
.catch(function (err) {
window.__v2BagError = (err && err.message) || String(err);
if (window.__v2CartTrace && window.__v2CartTrace.length < 30) {
window.__v2CartTrace.push('bag paint failed: ' + window.__v2BagError);
}
bagFailOpen();
})
.then(function () {
bagBusy = false;
if (bagAgain) { bagAgain = false; paintBagSoon(); }
});
}
function repaint() {
paintBagSoon();
paintMade();
updateWishCount();
busySync();
paintEmpty();
if (justAdded && paintJust() && !justShown) {
justShown = true;
if (phone()) { addedShow(true); show('bag'); } else { show('just'); }
}
pinSync();
watchTerms();
payPair();
applyPanels();
}
function phone() {
return !!(window.matchMedia && window.matchMedia('(max-width:900px)').matches);
}
var CART_MO_RES = [
/(?:[$€£¥]|CA\$|C\$)\s?([\d][\d.,]*)\s*(?:\/|\bper\b|\ba\b)?\s*(?:mo\b|month\b|mois\b)/i,
/(?:monthly|per month|a month)[^$€£¥]{0,32}(?:[$€£¥]|CA\$|C\$)\s?([\d][\d.,]*)/i
];
function moTermNodes() {
return drawer.querySelectorAll('[data-v2c-terms] shopify-payment-terms, [data-v2c-terms]');
}
function moText(el) {
var t = '';
try { t += el.textContent || ''; } catch (e) {}
try { if (el.shadowRoot) t += ' ' + (el.shadowRoot.textContent || ''); } catch (e) {}
return t.replace(/\s+/g, ' ');
}
function moWhole(num) {
var m = /^(.*?)([.,])(\d{2})$/.exec(num);
var whole = m ? m[1] : num;
var cents = m ? parseInt(m[3], 10) : 0;
var sep = (whole.match(/[.,  ]/) || [''])[0];
var digits = whole.replace(/\D/g, '');
if (!digits) return num;
var n = parseInt(digits, 10);
if (cents > 0) n += 1;
var out = String(n);
if (sep && out.length > 3) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
return out;
}
function moFigure() {
var host = drawer.querySelector('[data-v2c-mo]');
var cents = !host || host.getAttribute('data-mo-cents') === '1';
var n = moTermNodes();
for (var i = 0; i < n.length; i++) {
var t = moText(n[i]);
if (!t) continue;
for (var r = 0; r < CART_MO_RES.length; r++) {
var m = CART_MO_RES[r].exec(t);
if (m && m[1]) return '$' + (cents ? m[1] : moWhole(m[1]));
}
}
return '';
}
function payFig(amount) {
var b = drawer.querySelector('.v2c-pay b');
if (!b) return;
var row = drawer.querySelector('[data-v2c-payrow]');
var kept = b.getAttribute('data-full') || '';
var full = bagText(amount == null ? '' : amount) || kept || bagText(b.textContent);
if (!full) return;
if (full !== kept) b.setAttribute('data-full', full);
var two = !!(row && row.hasAttribute('data-v2c-two'));
var want = two ? full.replace(/\s[A-Za-z]{3}$/, '') : full;
if (want && bagText(b.textContent) !== want) b.textContent = want;
}
function payPair() {
var row = drawer.querySelector('[data-v2c-payrow]');
if (!row) return;
var mo = row.querySelector('[data-v2c-mo]');
var fig = row.querySelector('[data-v2c-mofig]');
if (!mo || !fig) { fitPay(); return; }
var amt = moFigure();
var show = !!amt && !row.hidden;
var changed = false;
if (show && fig.textContent !== amt) { fig.textContent = amt; changed = true; }
if (mo.hasAttribute('hidden') === show) {
if (show) mo.removeAttribute('hidden'); else mo.setAttribute('hidden', '');
changed = true;
}
var vr = row.querySelector('[data-v2c-vr]');
if (vr && vr.hasAttribute('hidden') === show) {
if (show) vr.removeAttribute('hidden'); else vr.setAttribute('hidden', '');
changed = true;
}
var dup = row.querySelector('.v2c-marks [data-v2c-dup]');
if (dup && dup.hasAttribute('hidden') !== show) {
if (show) dup.setAttribute('hidden', ''); else dup.removeAttribute('hidden');
changed = true;
}
if (row.hasAttribute('data-v2c-two') !== show) {
if (show) row.setAttribute('data-v2c-two', ''); else row.removeAttribute('data-v2c-two');
changed = true;
}
payFig();
if (changed || show) fitPay();
}
var CART_FIT_MAX = 6;
function fitPay() {
var row = drawer.querySelector('[data-v2c-payrow]');
if (!row || !row.hasAttribute('data-v2c-two') || row.hidden) return;
var mo = row.querySelector('[data-v2c-mo]');
var marks = row.querySelector('.v2c-marks');
if (!mo || !marks || mo.hasAttribute('hidden')) return;
row.removeAttribute('data-v2c-paystack');
function fits() {
var a = mo.getBoundingClientRect();
var c = marks.getBoundingClientRect();
if (Math.abs((a.top + a.bottom) / 2 - (c.top + c.bottom) / 2) >= 9) return false;
var rr = row.getBoundingClientRect();
var pad = parseFloat(getComputedStyle(row).paddingRight) || 0;
return c.right <= rr.right - pad + 1;   /* a pixel for rounding */
}
for (var lvl = 0; lvl <= CART_FIT_MAX; lvl++) {
row.setAttribute('data-v2c-payfit', String(lvl));
if (!(row.clientWidth > 40)) return;
if (fits()) return;
}
row.setAttribute('data-v2c-paystack', '');
}
var moT = 0;
function payPairSoon() { clearTimeout(moT); moT = setTimeout(payPair, 60); }
function watchTerms() {
var n = moTermNodes();
for (var i = 0; i < n.length; i++) {
if (n[i].__v2moWatch) continue;
n[i].__v2moWatch = 1;
try {
own(new MutationObserver(payPairSoon))
.observe(n[i], { childList: true, subtree: true, characterData: true });
if (n[i].shadowRoot) {
own(new MutationObserver(payPairSoon))
.observe(n[i].shadowRoot, { childList: true, subtree: true, characterData: true });
}
} catch (e) {}
}
}
function pinSync() {
var inner = drawer.querySelector('.drawer__inner');
var ck = drawer.querySelector('#CartDrawer-Checkout');
if (!inner || !ck) return;
var pin = inner.querySelector('[data-v2c-pin]');
var foot = drawer.querySelector('.v2c-foot');
var pay = drawer.querySelector('[data-v2c-payrow]') || drawer.querySelector('.v2c-pay');
var marks = drawer.querySelector('[data-v2c-payrow]') ? null : drawer.querySelector('.v2c-marks');
if (!phone()) {
if (pin && foot) {
var anchor = null;
if (pin.contains(ck)) foot.insertBefore(ck, anchor);
var sz = pin.querySelector('a.sezzle-checkout-button');
if (sz) foot.insertBefore(sz, ck.nextSibling);
if (pay && pin.contains(pay)) foot.insertBefore(pay, anchor);
if (marks && pin.contains(marks)) foot.insertBefore(marks, anchor);
var wrap = pin.querySelector('.v2c-pin-pay');
if (wrap && !wrap.firstElementChild) wrap.parentNode.removeChild(wrap);
}
if (pin && !pin.firstElementChild) pin.parentNode.removeChild(pin);
return;
}
if (!pin) {
pin = document.createElement('div');
pin.className = 'v2c-pin';
pin.setAttribute('data-v2c-pin', '');
inner.appendChild(pin);
}
if (!pin.contains(ck)) {
var sz2 = drawer.querySelector('.v2c-foot a.sezzle-checkout-button');
pin.insertBefore(ck, pin.firstChild);
if (sz2) pin.insertBefore(sz2, ck.nextSibling);
}
if (pay && !pin.contains(pay)) {
var w = pin.querySelector('.v2c-pin-pay');
if (!w) { w = document.createElement('div'); w.className = 'v2c-pin-pay'; pin.appendChild(w); }
w.appendChild(pay);
if (marks) w.appendChild(marks);
}
}
if (window.matchMedia) {
var mq = window.matchMedia('(max-width:900px)');
var mqRun = function () { pinSync(); payPair(); };
if (mq.addEventListener) {
mq.addEventListener('change', mqRun);
teardown.push(function () { mq.removeEventListener('change', mqRun); });
} else if (mq.addListener) {
mq.addListener(mqRun);
teardown.push(function () { mq.removeListener(mqRun); });
}
}
var addedOn = false;   /* true while the "Added to your bag" banner should be showing (phones, after an add) */
function addedShow(on) {
addedOn = !!on;
var el = drawer.querySelector('[data-v2c-added]');
if (el && el.hidden === !!on) el.hidden = !on;
}
if (!window.__v2AddedWatch && window.MutationObserver) {
var wasActive = drawer.classList.contains('active');
window.__v2AddedWatch = own(new MutationObserver(function () {
var on = drawer.classList.contains('active');
/* A re-render briefly drops 'active' (~35ms) and puts it back. Right after an add that is not a real close, so keep the
   "Added to your bag" banner through it; the 4s timer in v2cSubmit hides it if the drawer really did close. */
if (!on) { if (!justAdded) addedShow(false); wasActive = false; return; }
if (wasActive) return;
wasActive = true;
wake();
pkgSeed();
if (current !== 'bag' && Date.now() - wishOpenAt > 1200) show('bag');
}));
window.__v2AddedWatch.observe(drawer, { attributes: true, attributeFilter: ['class'] });
}
var OWN_WRITES = '[data-v2c-payrow],[data-v2c-terms],[data-v2c-pin],' +
'[data-v2c-added],[data-v2c-busy],.v2c-made';
function allOurs(recs) {
for (var i = 0; i < recs.length; i++) {
var t = recs[i].target;
var el = t && t.nodeType === 1 ? t : (t && t.parentElement);
if (!el || !el.closest || !el.closest(OWN_WRITES)) return false;
}
return true;
}
var AWAKE_FOR = 15000;
var lastTouch = Date.now();
function awake() { return Date.now() - lastTouch < AWAKE_FOR; }
function wake() {
var was = awake();
lastTouch = Date.now();
if (!was) repaint();
}
['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
document.addEventListener(ev, wake, { capture: true, passive: true });
teardown.push(function () { document.removeEventListener(ev, wake, true); });
});
function v2cVisible() { if (!document.hidden) wake(); }
document.addEventListener('visibilitychange', v2cVisible);
teardown.push(function () { document.removeEventListener('visibilitychange', v2cVisible); });
var host = document.getElementById('CartDrawer');
if (host) {
own(new MutationObserver(function (recs) {
if (allOurs(recs)) return;
if (!awake()) return;
clearTimeout(window.__v2cT);
window.__v2cT = setTimeout(repaint, 40);
})).observe(host, { childList: true, subtree: true });
}
repaint();
}());
}
v2run();
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { try { v2run(); } catch (e) {} });
}
})();
